import { Button } from 'common/components/Button/Button'
import { BUTTON_MODIFIER, BUTTON_PROPORTION } from 'common/constants/buttonConstants'
import { formatMoney } from 'common/services/format'

import { ReactComponent as RingIcon } from '../assets/ring.svg'

import styles from './waiting-view.module.scss'

type Props = {
  amount: number
  terminalLabel: string
  message?: string
  onCancel: () => void
}

export const WaitingView = ({ amount, terminalLabel, message, onCancel }: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.ringWrapper}>
        <RingIcon className={styles.ringIcon} width={96} height={96} />
      </div>
      <div className={styles.textGroup}>
        <h3 className={styles.title}>Waiting for payment...</h3>
        <p className={styles.subtitle}>
          Present the card on
          {terminalLabel && <span className={styles.terminalName}>{terminalLabel}</span>}
        </p>
        {message && <p className={styles.message}>{message}</p>}
      </div>
      <div className={styles.amountCard}>
        <span className={styles.amountLabel}>Amount due</span>
        <span className={styles.amountValue}>
          <span className={styles.amountSymbol}>$</span>
          {formatMoney(amount).replace(/^\$/, '')}
        </span>
      </div>
      <div className={styles.footer}>
        <Button
          modifier={BUTTON_MODIFIER.SECONDARY}
          proportion={BUTTON_PROPORTION.LARGE}
          onClick={onCancel}
          className={styles.cancelButton}>
          Cancel Transaction
        </Button>
      </div>
    </div>
  )
}
